var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrabSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "-6 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64286 5H3.35714C3.1599 5 3 5.1599 3 5.35714V9.64286C3 9.8401 3.1599 10 3.35714 10H7.64286C7.8401 10 8 9.8401 8 9.64286V5.35714C8 5.1599 7.8401 5 7.64286 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 5H12.8571C12.6599 5 12.5 5.1599 12.5 5.35714V9.64286C12.5 9.8401 12.6599 10 12.8571 10H17.1429C17.3401 10 17.5 9.8401 17.5 9.64286V5.35714C17.5 5.1599 17.3401 5 17.1429 5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64286 13H3.35714C3.1599 13 3 13.1599 3 13.3571V17.6429C3 17.8401 3.1599 18 3.35714 18H7.64286C7.8401 18 8 17.8401 8 17.6429V13.3571C8 13.1599 7.8401 13 7.64286 13Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 13H12.8571C12.6599 13 12.5 13.1599 12.5 13.3571V17.6429C12.5 17.8401 12.6599 18 12.8571 18H17.1429C17.3401 18 17.5 17.8401 17.5 17.6429V13.3571C17.5 13.1599 17.3401 13 17.1429 13Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64286 21H3.35714C3.1599 21 3 21.1599 3 21.3571V25.6429C3 25.8401 3.1599 26 3.35714 26H7.64286C7.8401 26 8 25.8401 8 25.6429V21.3571C8 21.1599 7.8401 21 7.64286 21Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 21H12.8571C12.6599 21 12.5 21.1599 12.5 21.3571V25.6429C12.5 25.8401 12.6599 26 12.8571 26H17.1429C17.3401 26 17.5 25.8401 17.5 25.6429V21.3571C17.5 21.1599 17.3401 21 17.1429 21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrabSharp);
export default __webpack_public_path__ + "static/media/GrabSharp.db30b5c4086555f3d1e8d64e9238c4a2.svg";
export { ForwardRef as ReactComponent };